export function quizMuseum () {
	(function(w, d, s, o){
		var j = d.createElement(s); j.async = true; j.src = '//script.marquiz.ru/v2.js';j.onload = function() {
			if (document.readyState !== 'loading') Marquiz.init(o);
			else document.addEventListener("DOMContentLoaded", function() {
			Marquiz.init(o);
			});
		};
		d.head.insertBefore(j, d.head.firstElementChild);
		})(window, document, 'script', {
			host: '//quiz.marquiz.ru',
			region: 'eu',
			id: '63c903dfcfdcf4004f9f1b39',
			autoOpen: false,
			autoOpenFreq: 'once',
			openOnExit: false,
			disableOnMobile: false
		}
		);
		//инлайн
		(function(t, p) {window.Marquiz ? Marquiz.add([t, p]) : document.addEventListener('marquizLoaded', function() {Marquiz.add([t, p])})})('Inline', {id: '63c903dfcfdcf4004f9f1b39', buttonText: 'Оставить заявку', bgColor: '#d72819', textColor: '#ffffff', rounded: true, blicked: true, buttonOnMobile: true, width: '', radius: '10', indent: '10'})
		//по кнопке
		/* (function(t, p) {window.Marquiz ? Marquiz.add([t, p]) : document.addEventListener('marquizLoaded', function() {
			Marquiz.add([t, p])})})('Button', {id: '63c903dfcfdcf4004f9f1b39', buttonText: 'Оставить заявку', bgColor: '#d72819', textColor: '#ffffff', rounded: true, blicked: true
		}) */


}
export function pswpMuseum (i) {

	// Initializes and opens PhotoSwipe
	var pswpElement = document.querySelectorAll('.pswp')[0];
	var itemsImg = [...document.querySelectorAll('.museum-page .equipment__item-image img')];
	var items = [];

	itemsImg.forEach((item,index) => {

		/* items.push({
			src: item.src,
			w: item.naturalWidth,
			h: item.naturalHeight
		}) */

		if (index == i) {
			items.push({
			src: item.src,
			w: item.naturalWidth,
			h: item.naturalHeight
		})
		}

	})

	var options = {
		bgOpacity: 0.5,
		index: +i
	};

	var gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
	gallery.init();
}
